import { lazy } from 'react';
// import UpatListConverterPage from '../pages/UpatListConverterPage';
import ResearcherSignup from '../pages/ResearcherSignup';
import { Navigate } from 'react-router-dom';
import HelpAccessGate from '../features/help/components/HelpAccessGate';

const Home = lazy(() => import("../pages/Home"));
const Faq = lazy(() => import("../pages/Faq"));
const About = lazy(() => import("../pages/About"));
const Documentation = lazy(() => import("../pages/Documentation"));
const Features = lazy(() => import("../pages/Features"));
const Contact = lazy(() => import("../pages/Contact"));
const PatientLogin = lazy(() => import("../pages/PatientLogin"));
const ResearcherLogin = lazy(() => import("../pages/ResearcherLogin"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/ResetPassword"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Reports = lazy(() => import("../pages/Reports"));
const ReportBuilder = lazy(() => import("../pages/ReportBuilder"));
const NotFound = lazy(() => import("../pages/NotFound"));
const Patients = lazy(() => import("../pages/Patients"));
const PatientViewer = lazy(() => import("../pages/PatientViewer"));
const ReportViewer = lazy(() => import("../pages/ReportViewer"));
const Settings = lazy(() => import("../pages/Settings"));
const Terms = lazy(() => import("../pages/Terms"));
const WorkflowGuide = lazy(() => import("../pages/WorkflowGuide"));

// admin sections
const AdminOverview = lazy(() => import("../pages/AdminOverview"));
const AdminUsers = lazy(() => import("../pages/AdminUsers"));
const AdminReports = lazy(() => import("../pages/AdminReports"));
const AdminSettings = lazy(() => import("../pages/AdminSettings"));
const AdminEmail = lazy(() => import("../pages/AdminEmail"));
const AdminTesting = lazy(() => import("../pages/AdminTesting"));
const AdminDatasets = lazy(() => import("../pages/AdminDatasets"));
const AdminVariables = lazy(() => import("../pages/AdminVariables"));
const AdminDatasetView = lazy(() => import("../pages/AdminDatasetView"));
const AdminUserEditView = lazy(() => import("../pages/AdminUserEditView"));

// Contains all public pages accessible in the page
export const publicRoutes = [
    {
        path: '/',
        element: <Home />,
    },
    {
        path: '/features',
        element: <Features />,
    },
    {
        path: '/faq',
        element: <Faq />,
    },
    {
        path: '/documentation',
        element: <Documentation />,
    },
    {
        path: '/about',
        element: <About />,
    },
    {
        path: '/terms-of-service',
        element: <Terms />,
    },
    {
        path: '/contact',
        element: <Contact />,
    },
    {
        path: '*',
        element: <NotFound />,
    }
];

export const privateRoutes = [
    {
        path: '/patients',
        element: <Patients />,
    },
    {
        path: '/patients/:patientId',
        element: <PatientViewer />,
    },
    {
        path: '/reports/:reportId',
        element: <ReportViewer />,
    },
    {
        path: '/dashboard',
        element: <Dashboard />,
    },
    {
        path: '/reports',
        element: <Reports />,
    },
    {
        path: '/new-report',
        element: <ReportBuilder />,
    },
    {
        path: '/help',
        element: (
            <HelpAccessGate>
                <WorkflowGuide />
            </HelpAccessGate>
        ),
    },
    {
        path: '/settings/:view',
        element: <Settings />,
    },
];

export const authRoutes = [
    {
        path: '/patient-login',
        element: <PatientLogin />,
    },
    {
        path: '/researcher-login',
        element: <ResearcherLogin />,
    },
    {
        path: '/researcher-signup',
        element: <ResearcherSignup />,
    },
    {
        path: '/forgot-password',
        element: <ForgotPassword />,
    },
    {
        path: '/reset-password/:token',
        element: <ResetPassword />,
    }
];

export const adminRoutes = [
    {
        path: '/admin',
        element: <Navigate to="/admin/overview" replace />,
    },
    {
        path: '/admin/overview',
        element: <AdminOverview />,
    },
    {
        path: '/admin/users',
        element: <AdminUsers />,
    },
    {
        path: '/admin/users/:userId',
        element: <AdminUserEditView />,
    },
    {
        path: '/admin/reports',
        element: <AdminReports />,
    },
    {
        path: '/admin/datasets',
        element: <AdminDatasets />,
    },
    {
        path: '/admin/variables',
        element: <AdminVariables />,
    },
    {
        path: '/admin/settings',
        element: <AdminSettings />,
    },
    {
        path: '/admin/email',
        element: <AdminEmail />,
    },
    {
        path: '/admin/debug',
        element: <AdminTesting />,
    },
    {
        path: '/admin/datasets/:datasetId',
        element: <AdminDatasetView />,
    }
];
